import { Box } from '@mui/material';
import React from 'react';
import { Button } from '@uplift/ui-v2';
import { FormikHelpers, useFormikContext } from 'formik';


export const FloatingActionBar: React.VFC<{
  onCancel: () => void;
  onDraftSubmit?: (values: Record<string, unknown>, helpers: FormikHelpers<Record<string, unknown>>) => Promise<unknown>;
}> = ({ onCancel, onDraftSubmit }) => {
  const formik = useFormikContext<Record<string, unknown>>();

  return (
    <Box position="sticky" bottom="76px" p={2} bgcolor="common.white" zIndex={1}>
      <Box display="flex" gap="8px" justifyContent="flex-end">
        <Button disabled={formik.isSubmitting} onClick={onCancel} color="secondary" variant="outlined">Cancel</Button>
        <Button
          loading={formik.isSubmitting}
          onClick={async () => {
            if (onDraftSubmit && !formik.isValid) {
              formik.setSubmitting(true);
              await onDraftSubmit(formik.values, formik);
              formik.setSubmitting(false);
            } else {
              formik.handleSubmit();
            }
          }}
          color="secondary"
          variant="contained"
        >Save</Button>
      </Box>
    </Box>
  );
};
